// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(7, 10, 20, 0.72);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(102, 126, 234, 0.25);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: white;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: #f0f0f0;
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  display: flex;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #eee;
  background: #f9f9f9;
}

.btn-cancel,
.btn-primary {
  flex: 1 1;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel {
  background: #f0f0f0;
  color: #333;
}

.btn-cancel:hover {
  background: #e0e0e0;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.3);
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Create Challenge Modal */
.create-challenge-modal .form-group {
  margin-bottom: 25px;
}

.create-challenge-modal {
  border: 1px solid rgba(102, 126, 234, 0.35);
  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.25);
}

.friendly-challenge-modal {
  border: 1px solid rgba(16, 185, 129, 0.45);
  box-shadow: 0 20px 60px rgba(16, 185, 129, 0.2);
}

.create-challenge-modal label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.create-challenge-modal small {
  display: block;
  margin-top: 4px;
  color: #999;
  font-size: 12px;
}

.friends-picker {
  display: grid;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fafafa;
}

.friend-dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.friend-dropdown-toggle:hover {
  border-color: #c7d2fe;
  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.12);
}

.friend-dropdown-caret {
  margin-left: auto;
  color: #6b7280;
  font-size: 12px;
}

.friend-search {
  width: 100%;
  padding: 9px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 13px;
}

.friend-search:focus {
  outline: none;
  border-color: #a5b4fc;
  box-shadow: 0 0 0 3px rgba(165, 180, 252, 0.25);
}

.friend-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.friend-option:hover {
  border-color: #c7d2fe;
  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.12);
}

.friend-option.selected {
  border-color: #667eea;
  background: #eef2ff;
}

.friend-status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #cbd5f5;
  box-shadow: 0 0 0 2px rgba(203, 213, 245, 0.35);
  flex: 0 0 10px;
}

.friend-status.online {
  background: #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);
}

.friend-name {
  color: #111827;
  font-weight: 600;
}

.input-with-unit {
  position: relative;
  display: flex;
  align-items: center;
}

.input-with-unit input {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.input-with-unit input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.input-with-unit .unit {
  position: absolute;
  right: 12px;
  color: #999;
  font-size: 12px;
  pointer-events: none;
}

.summary {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
}

.summary-row:last-child {
  margin-bottom: 0;
}

.summary-row span {
  color: #666;
}

.summary-row strong {
  color: #333;
  font-weight: 600;
}

.summary-row.total {
  padding-top: 10px;
  border-top: 1px solid #ddd;
  margin-top: 10px;
  margin-bottom: 10px;
}

.summary-row.total strong {
  color: #667eea;
  font-size: 16px;
}

.summary-row.available strong {
  color: #27ae60;
  font-size: 16px;
}

.info-box {
  background: #f0f7ff;
  border-left: 4px solid #667eea;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.info-box p {
  margin: 5px 0;
  font-size: 14px;
  color: #111827;
  line-height: 1.6;
}

.error-box {
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 15px;
}

.error-box p {
  margin: 5px 0;
  color: #c33;
  font-size: 12px;
}

.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 10px 12px;
  border-radius: 6px;
  margin-bottom: 15px;
  font-size: 13px;
}

/* Accept Challenge Modal */
.challenge-terms {
  background: white;
}

.challenge-terms h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.challenge-terms h4 {
  margin: 15px 0 10px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.term {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.term label {
  color: #666;
  font-weight: 500;
}

.term .value {
  color: #333;
  font-weight: 600;
}

.term .value.amount {
  color: #667eea;
  font-size: 15px;
}

.term.total {
  padding: 15px 0 10px 0;
  border-top: 2px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  margin: 10px 0;
}

.term.total .value.amount {
  color: #e74c3c;
  font-size: 18px;
}

.divider {
  height: 1px;
  background: #f0f0f0;
  margin: 15px 0;
}

.what-happens {
  background: #f0f7ff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.what-happens ul {
  margin: 10px 0;
  padding-left: 20px;
  list-style: none;
}

.what-happens li {
  margin-bottom: 6px;
  font-size: 12px;
  color: #555;
  line-height: 1.4;
}

.balance-check {
  background: #f9f9f9;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.balance-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
}

.balance-item:last-child {
  margin-bottom: 0;
}

.balance-item span {
  color: #666;
}

.balance-item strong {
  color: #333;
  font-weight: 600;
}

.balance-item strong.error {
  color: #e74c3c;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ChallengeModals.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(7, 10, 20, 0.72);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.45);\n  border: 1px solid rgba(102, 126, 234, 0.25);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n  position: sticky;\n  top: 0;\n  background: white;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  color: #333;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #999;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  gap: 10px;\n  padding: 20px;\n  border-top: 1px solid #eee;\n  background: #f9f9f9;\n}\n\n.btn-cancel,\n.btn-primary {\n  flex: 1;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-cancel {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.btn-cancel:hover {\n  background: #e0e0e0;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.3);\n}\n\n.btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Create Challenge Modal */\n.create-challenge-modal .form-group {\n  margin-bottom: 25px;\n}\n\n.create-challenge-modal {\n  border: 1px solid rgba(102, 126, 234, 0.35);\n  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.25);\n}\n\n.friendly-challenge-modal {\n  border: 1px solid rgba(16, 185, 129, 0.45);\n  box-shadow: 0 20px 60px rgba(16, 185, 129, 0.2);\n}\n\n.create-challenge-modal label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.create-challenge-modal small {\n  display: block;\n  margin-top: 4px;\n  color: #999;\n  font-size: 12px;\n}\n\n.friends-picker {\n  display: grid;\n  gap: 8px;\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fafafa;\n}\n\n.friend-dropdown-toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.friend-dropdown-toggle:hover {\n  border-color: #c7d2fe;\n  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.12);\n}\n\n.friend-dropdown-caret {\n  margin-left: auto;\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.friend-search {\n  width: 100%;\n  padding: 9px 12px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  font-size: 13px;\n}\n\n.friend-search:focus {\n  outline: none;\n  border-color: #a5b4fc;\n  box-shadow: 0 0 0 3px rgba(165, 180, 252, 0.25);\n}\n\n.friend-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.friend-option:hover {\n  border-color: #c7d2fe;\n  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.12);\n}\n\n.friend-option.selected {\n  border-color: #667eea;\n  background: #eef2ff;\n}\n\n.friend-status {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #cbd5f5;\n  box-shadow: 0 0 0 2px rgba(203, 213, 245, 0.35);\n  flex: 0 0 10px;\n}\n\n.friend-status.online {\n  background: #22c55e;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);\n}\n\n.friend-name {\n  color: #111827;\n  font-weight: 600;\n}\n\n.input-with-unit {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-with-unit input {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.input-with-unit input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.input-with-unit .unit {\n  position: absolute;\n  right: 12px;\n  color: #999;\n  font-size: 12px;\n  pointer-events: none;\n}\n\n.summary {\n  background: #f9f9f9;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 15px;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.summary-row:last-child {\n  margin-bottom: 0;\n}\n\n.summary-row span {\n  color: #666;\n}\n\n.summary-row strong {\n  color: #333;\n  font-weight: 600;\n}\n\n.summary-row.total {\n  padding-top: 10px;\n  border-top: 1px solid #ddd;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.summary-row.total strong {\n  color: #667eea;\n  font-size: 16px;\n}\n\n.summary-row.available strong {\n  color: #27ae60;\n  font-size: 16px;\n}\n\n.info-box {\n  background: #f0f7ff;\n  border-left: 4px solid #667eea;\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n.info-box p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.6;\n}\n\n.error-box {\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 15px;\n}\n\n.error-box p {\n  margin: 5px 0;\n  color: #c33;\n  font-size: 12px;\n}\n\n.error-message {\n  background: #fee;\n  border: 1px solid #fcc;\n  color: #c33;\n  padding: 10px 12px;\n  border-radius: 6px;\n  margin-bottom: 15px;\n  font-size: 13px;\n}\n\n/* Accept Challenge Modal */\n.challenge-terms {\n  background: white;\n}\n\n.challenge-terms h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.challenge-terms h4 {\n  margin: 15px 0 10px 0;\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.term {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 14px;\n}\n\n.term label {\n  color: #666;\n  font-weight: 500;\n}\n\n.term .value {\n  color: #333;\n  font-weight: 600;\n}\n\n.term .value.amount {\n  color: #667eea;\n  font-size: 15px;\n}\n\n.term.total {\n  padding: 15px 0 10px 0;\n  border-top: 2px solid #f0f0f0;\n  border-bottom: 1px solid #f0f0f0;\n  margin: 10px 0;\n}\n\n.term.total .value.amount {\n  color: #e74c3c;\n  font-size: 18px;\n}\n\n.divider {\n  height: 1px;\n  background: #f0f0f0;\n  margin: 15px 0;\n}\n\n.what-happens {\n  background: #f0f7ff;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 15px;\n}\n\n.what-happens ul {\n  margin: 10px 0;\n  padding-left: 20px;\n  list-style: none;\n}\n\n.what-happens li {\n  margin-bottom: 6px;\n  font-size: 12px;\n  color: #555;\n  line-height: 1.4;\n}\n\n.balance-check {\n  background: #f9f9f9;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 15px;\n}\n\n.balance-item {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.balance-item:last-child {\n  margin-bottom: 0;\n}\n\n.balance-item span {\n  color: #666;\n}\n\n.balance-item strong {\n  color: #333;\n  font-weight: 600;\n}\n\n.balance-item strong.error {\n  color: #e74c3c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
